import { Type } from 'class-transformer'
import { MyWritingOptionType } from './MyWritingOptionType'

export class MyWritingOptionResponse {
  page: number

  @Type(() => MyWritingOptionType)
  data: MyWritingOptionType[]
}
